import React, { useEffect } from "react";
import LoaderSVG from "./loadersvg";

interface TypingEffectProps {
    text: string;
    onComplete?: () => void;
}

const TypingEffect: React.FC<TypingEffectProps> = ({ text, onComplete }) => {

    useEffect(() => {
        if (text !== '**loading**') {
            if (onComplete) {
                onComplete()
            }
        }
    }, [text])
    return (<>{<LoaderSVG width={'2em'} height={'2em'} bgcolor={'#f9f9f9'} className={'loadersvg'} />}</>)
}

export default TypingEffect